export class Sequencer {
    constructor() {
        this.evaluationOrder = [
            { key: 'taskQueue', condition: null },
            { key: 'createTransferQueue', condition: null },
            { key: 'createFileQueue', condition: this.hasEnoughFilesProcessing },
            { key: 'createPartsQueue', condition: this.hasEnoughPartsProcessing },
            { key: 'uploadPartQueue', condition: null },
            { key: 'updateFileQueue', condition: null },
            { key: 'createFileQueue', condition: null },
            { key: 'lockTransferQueue', condition: null },
        ];
    }
    hasEnoughFilesProcessing(context) {
        return Boolean(context.transfer.numberOfProcessingFiles() <= context.transfer.parallelFiles);
    }
    hasEnoughPartsProcessing(context) {
        return Boolean(context.transfer.numberOfProcessingParts() <= context.transfer.parallelMaxParts);
    }
    hasOne(evaluation, context) {
        return context[evaluation.key].hasOne();
    }
    evaluateCondition(evaluation, context) {
        if (evaluation.condition) {
            return evaluation.condition(context);
        }
        return true;
    }
    shift(evaluation, context) {
        return context[evaluation.key].shift();
    }
    evaluateNextTask(context) {
        if ((context === null || context === void 0 ? void 0 : context.localEndOfQueueTimestamp) === undefined || (context === null || context === void 0 ? void 0 : context.localEndOfQueueTimestamp) < Date.now()) {
            for (const evaluation of this.evaluationOrder) {
                if (this.hasOne(evaluation, context) && this.evaluateCondition(evaluation, context)) {
                    const nextTask = this.shift(evaluation, context);
                    return nextTask;
                }
            }
        }
        return null;
    }
}
